module.exports = __webpack_public_path__ + "media/images/workplace/banners/uhrs_qualify_banner_variant1_image-4414882a2c3a179ab164c0f4ab28b9de.jpg";